import elTableInfiniteScroll from 'el-table-infinite-scroll';
import ElementUI from 'element-ui'; //引用elementui
import 'element-ui/lib/theme-chalk/index.css'; //element样式
import $ from 'jquery';
import md5 from 'js-md5'; //引入
import moment from 'moment';
import 'moment/locale/zh-cn';
import Vue from "vue";
//百度地图
import BaiduMap from 'vue-baidu-map';
import axios from './api/index'; //引用简单封装过得axios
import App from "./App.vue";
import './assets/icon/iconfont1.css';
import './assets/icon/login_icon.css';
import './assets/js/iconfont.js';
import './assets/scss/iconfont.css';
import './assets/scss/style.scss';
import arealist from './options/areaList1';
import option_transform from './options/optionsdata';
import router from "./router"; //路由引用
import store from "./store"; //引用vuex 下方挂载 全局可用 this.$store 等方法和变量
import {
    deleteSessionStorage, getSessionStorage, setSessionStorage
} from './utils/auth';
// console.log('TcVod :>> ', TcVod);
// Vue.prototype.$TcVod = TcVod;//添加
Vue.prototype.$md5 = md5;//添加
moment.locale('zh-cn');
// import echarts from 'echarts'  
// Vue.prototype.$echarts = echarts
Vue.use(ElementUI, {
    size: 'medium' // set element-ui default size
}); //全局引用elementui
Vue.prototype.$http = axios; //Vue.prototype vue原型链 这里挂在之后 全局this.$http.post()  相当于 axios.post()
Vue.prototype.$ = $;
Vue.prototype.$Bus = new Vue; //这里先定义一个$Bus定义到vue原型链上,就是用this.$Bus可以调用 定义得变量是新初始化得一个vue实例  //用于兄弟组件之间发送事件this.$Bus.$emit('fangfa') this.$Bus.$on('fangfa') 等同于父子组件得 this.$emit('fangfa') this.$on('fangfa')
Vue.config.productionTip = false;

Vue.use(BaiduMap, {
    ak: 'fBO4B25FGiz9uXD4WBBMymZoICpi7op0' //自己去百度API申请，免费的
})

Vue.prototype.GLOBALState = option_transform
Vue.prototype.GLOBALArealist = arealist
Vue.prototype.$setSessionStorage = setSessionStorage
Vue.prototype.$getSessionStorage = getSessionStorage
Vue.prototype.$deleteSessionStorage = deleteSessionStorage



Vue.use(elTableInfiniteScroll);

import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';

Vue.use(mavonEditor)


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");